import { render, staticRenderFns } from "./ModulePostcardMessage.vue?vue&type=template&id=be16e43c&scoped=true&"
import script from "./ModulePostcardMessage.vue?vue&type=script&lang=js&"
export * from "./ModulePostcardMessage.vue?vue&type=script&lang=js&"
import style0 from "./ModulePostcardMessage.vue?vue&type=style&index=0&id=be16e43c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be16e43c",
  null
  
)

export default component.exports